export const CRETE_ENCOUNTER_LAB = 'encounterLabs/CRETE_ENCOUNTER_LAB';
export const GET_LABS_FOR_DROPDOWN = 'encounterLabs/GET_LABS_FOR_DROPDOWN';
export const GET_LABS_LIST = 'encounterLabs/GET_LABS_LIST';
export const EDIT_LAB = 'encounterLabs/EDIT_LAB';
export const DELETE_LAB = 'encounterLabs/DELETE_LAB';
export const SHARE_LAB = 'encounterLabs/SHARE_LAB';
export const UNSHARE_LAB = 'encounterLabs/UNSHARE_LAB';
export const SAVE_RESULTS = 'encounterLabs/SAVE_RESULTS';
export const DELETE_RESULT = 'encounterLabs/DELETE_RESULT';
export const SHARE_LAB_WITH_PATIENT = 'encounterLabs/SHARE_LAB_WITH_PATIENT';


export function createEncounterLab(encounterId, fields) {
    return {
        type: CRETE_ENCOUNTER_LAB,
        httpRequest: {
            method: 'post',
            path: `/encounterLabs/${encounterId}`,
            data: fields,
        },
    };
}

export function editLab(labId, fields) {
    return {
        type: EDIT_LAB,
        httpRequest: {
            method: 'put',
            path: `/encounterLabs/${labId}`,
            data: fields,
        },
        fields,
        id: labId,
    };
}

export function deleteLab(labId) {
    return {
        type: DELETE_LAB,
        httpRequest: {
            method: 'del',
            path: `/encounterLabs/${labId}`,
        },
        id: labId,
    };
}

export function shareLab(labId) {
    return {
        type: SHARE_LAB,
        httpRequest: {
            method: 'put',
            path: `/encounterLabs/share/${labId}`,
        },
        id: labId,
        fields: {isShared: true},
    };
}

export function unshareLab(labId) {
    return {
        type: SHARE_LAB,
        httpRequest: {
            method: 'put',
            path: `/encounterLabs/unshare/${labId}`,
        },
        id: labId,
        fields: {isShared: false},
    };
}

export function getLabsList(encounterId, {offset, limit}) {
    return {
        type: GET_LABS_LIST,
        httpRequest: {
            method: 'get',
            path: `/encounterLabs/${encounterId}`,
            params: {
                offset,
                limit,
            },
        },
        offset,
        limit,
    };
}

export function getLabsForDropdown(search) {
    return {
        type: GET_LABS_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/encounterLabs/dropdown/list',
            params: {
                search,
            },
        },
    };
}

export function saveResults(labId, files) {
    return {
        type: SAVE_RESULTS,
        httpRequest: {
            method: 'post',
            path: `/encounterLabs/results/${labId}`,
            data: {
                files,
            },
        },
    };
}

export function deleteResult(labId, attachmentId) {
    return {
        type: DELETE_RESULT,
        httpRequest: {
            method: 'del',
            path: `/encounterLabs/${labId}/result/${attachmentId}`,
        },
        labId,
        attachmentId,
    };
}

export function shareLabWithPatient(labId) {
    return {
        type: SHARE_LAB_WITH_PATIENT,
        httpRequest: {
            method: 'post',
            path: `/encounterLabs/share/with/patient/${labId}`,
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/encounterLabs/encounterLabActions.js